import type { FunctionalComponent as FC } from 'preact';

import { Footnote } from '@vkontakte/vkui';

import { useWidget } from '../../context/WidgetContext';
import { getDateLiteral, isTheSameDate } from '../../utils';

import styles from './styles.module.css';

interface Props {
  prevDate: string;
  currentDate: string;
  showDateAlways?: boolean;
}

export const MessagesDate: FC<Props> = ({ prevDate, currentDate, showDateAlways }) => {
  const { locale } = useWidget();
  const isTheSameDay = isTheSameDate(new Date(prevDate), new Date(currentDate));

  if (!showDateAlways && prevDate && isTheSameDay) {
    return null;
  }

  return (
    <Footnote className={styles.date} Component="p">
      {getDateLiteral(currentDate, locale)}
    </Footnote>
  );
};
